var _rect, _g, _g2, _g3, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackRentAiVertical(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 188,
    viewBox: "0 0 248 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 123.72,
    y: 30.3804,
    width: 46.344,
    height: 46.344,
    rx: 7.12985,
    transform: "rotate(45 123.72 30.3804)",
    fill: "url(#paint0_linear_4798_695)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 94.4854,
    y: 48.916,
    width: 58.9287,
    height: 58.9287
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.73px)",
      clipPath: "url(#bgblur_0_4798_695_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4798_695)",
    "data-figma-bg-blur-radius": 5.46435
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.9497,
    y: 54.3804,
    width: 48,
    height: 48,
    rx: 12,
    fill: "#BCE4F1",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 123.926,
    y: 59.416,
    width: 16.4326,
    height: 34.2007
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.73px)",
      clipPath: "url(#bgblur_1_4798_695_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_4798_695)",
    "data-figma-bg-blur-radius": 5.46435
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.818 69.7365C130.477 69.7365 129.39 68.6494 129.39 67.3084C129.39 65.9674 130.477 64.8804 131.818 64.8804H132.466C133.807 64.8804 134.894 65.9674 134.894 67.3084C134.894 68.6494 133.807 69.7365 132.466 69.7365H131.818ZM132.142 88.1523C130.622 88.1523 129.39 86.9202 129.39 85.4004V75.5235C129.39 74.0036 130.622 72.7715 132.142 72.7715C133.662 72.7715 134.894 74.0036 134.894 75.5235V85.4004C134.894 86.9202 133.662 88.1523 132.142 88.1523Z",
    fill: "#DBF6FF",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 107.985,
    y: 59.416,
    width: 16.4326,
    height: 34.2007
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.73px)",
      clipPath: "url(#bgblur_2_4798_695_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_4798_695)",
    "data-figma-bg-blur-radius": 5.46435
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.878 69.7365C114.537 69.7365 113.45 68.6494 113.45 67.3084C113.45 65.9674 114.537 64.8804 115.878 64.8804H116.526C117.867 64.8804 118.954 65.9674 118.954 67.3084C118.954 68.6494 117.867 69.7365 116.526 69.7365H115.878ZM116.202 88.1523C114.682 88.1523 113.45 86.9202 113.45 85.4004V75.5235C113.45 74.0036 114.682 72.7715 116.202 72.7715C117.722 72.7715 118.954 74.0036 118.954 75.5235V85.4004C118.954 86.9202 117.722 88.1523 116.202 88.1523Z",
    fill: "#DBF6FF",
    fillOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.5741 150.06V135.24H88.1264V138.836L87.7696 138.369C87.9526 137.893 88.1904 137.459 88.4832 137.065C88.7759 136.663 89.1144 136.334 89.4986 136.077C89.8737 135.803 90.2899 135.593 90.7473 135.446C91.2138 135.291 91.6895 135.199 92.1744 135.172C92.6592 135.135 93.1257 135.158 93.574 135.24V137.93C93.0892 137.802 92.5494 137.765 91.9548 137.82C91.3693 137.875 90.8296 138.063 90.3356 138.383C89.8691 138.685 89.4986 139.05 89.2241 139.48C88.9589 139.91 88.7668 140.391 88.6478 140.921C88.5289 141.443 88.4694 141.996 88.4694 142.582V150.06H85.5741ZM102.492 150.472C101.019 150.472 99.7247 150.152 98.6087 149.511C97.5018 148.862 96.6373 147.961 96.0152 146.808C95.4023 145.646 95.0958 144.301 95.0958 142.774C95.0958 141.155 95.3977 139.75 96.0015 138.561C96.6144 137.372 97.4652 136.452 98.5538 135.803C99.6424 135.153 100.909 134.829 102.355 134.829C103.864 134.829 105.149 135.181 106.211 135.885C107.272 136.581 108.063 137.573 108.585 138.863C109.115 140.153 109.325 141.685 109.216 143.46H106.348V142.417C106.33 140.697 106 139.426 105.36 138.602C104.729 137.779 103.764 137.367 102.465 137.367C101.028 137.367 99.9488 137.82 99.2261 138.726C98.5035 139.631 98.1421 140.94 98.1421 142.65C98.1421 144.279 98.5035 145.541 99.2261 146.437C99.9488 147.325 100.992 147.768 102.355 147.768C103.251 147.768 104.024 147.567 104.674 147.165C105.332 146.753 105.845 146.168 106.211 145.408L109.024 146.3C108.447 147.627 107.574 148.656 106.403 149.388C105.232 150.11 103.928 150.472 102.492 150.472ZM97.209 143.46V141.223H107.789V143.46H97.209ZM122.294 150.06V142.774C122.294 142.197 122.243 141.607 122.143 141.004C122.051 140.391 121.868 139.824 121.594 139.302C121.328 138.781 120.949 138.36 120.455 138.04C119.97 137.719 119.334 137.559 118.547 137.559C118.035 137.559 117.55 137.646 117.093 137.82C116.636 137.985 116.233 138.255 115.885 138.63C115.547 139.005 115.277 139.499 115.076 140.112C114.884 140.725 114.788 141.47 114.788 142.348L113.004 141.676C113.004 140.331 113.255 139.147 113.759 138.122C114.262 137.088 114.984 136.283 115.927 135.707C116.869 135.131 118.008 134.842 119.343 134.842C120.368 134.842 121.228 135.007 121.923 135.336C122.618 135.666 123.181 136.1 123.611 136.64C124.05 137.171 124.384 137.751 124.613 138.383C124.841 139.014 124.997 139.631 125.079 140.235C125.161 140.839 125.203 141.37 125.203 141.827V150.06H122.294ZM111.879 150.06V135.24H114.445V139.522H114.788V150.06H111.879ZM137.257 150.06C136.324 150.243 135.409 150.321 134.513 150.293C133.616 150.266 132.816 150.092 132.111 149.772C131.407 149.452 130.876 148.949 130.519 148.262C130.199 147.65 130.025 147.028 129.998 146.396C129.98 145.756 129.971 145.033 129.971 144.228V131.124H132.852V144.091C132.852 144.686 132.857 145.202 132.866 145.642C132.884 146.081 132.98 146.451 133.154 146.753C133.483 147.32 134.005 147.645 134.718 147.727C135.441 147.801 136.287 147.768 137.257 147.631V150.06ZM127.13 137.546V135.24H137.257V137.546H127.13ZM139.009 150.06L145.431 130.3H149.561L155.983 150.06H153.006L147.091 132.029H147.832L141.987 150.06H139.009ZM142.344 145.6V142.911H152.663V145.6H142.344ZM158.719 150.06V130.3H161.587V150.06H158.719Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4798_695",
    x: 94.4854,
    y: 48.916,
    width: 58.9287,
    height: 58.9287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.273217,
    dy: 0.136609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.683043
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4798_695"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_4798_695_clip_path",
    transform: "translate(-94.4854 -48.916)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.9497,
    y: 54.3804,
    width: 48,
    height: 48,
    rx: 12
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4798_695",
    x: 123.926,
    y: 59.416,
    width: 16.4326,
    height: 34.2007,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.273217,
    dy: 0.136609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.683043
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4798_695"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_4798_695_clip_path",
    transform: "translate(-123.926 -59.416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.818 69.7365C130.477 69.7365 129.39 68.6494 129.39 67.3084C129.39 65.9674 130.477 64.8804 131.818 64.8804H132.466C133.807 64.8804 134.894 65.9674 134.894 67.3084C134.894 68.6494 133.807 69.7365 132.466 69.7365H131.818ZM132.142 88.1523C130.622 88.1523 129.39 86.9202 129.39 85.4004V75.5235C129.39 74.0036 130.622 72.7715 132.142 72.7715C133.662 72.7715 134.894 74.0036 134.894 75.5235V85.4004C134.894 86.9202 133.662 88.1523 132.142 88.1523Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_4798_695",
    x: 107.985,
    y: 59.416,
    width: 16.4326,
    height: 34.2007,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.273217,
    dy: 0.136609
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.683043
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4798_695"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_4798_695_clip_path",
    transform: "translate(-107.985 -59.416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.878 69.7365C114.537 69.7365 113.45 68.6494 113.45 67.3084C113.45 65.9674 114.537 64.8804 115.878 64.8804H116.526C117.867 64.8804 118.954 65.9674 118.954 67.3084C118.954 68.6494 117.867 69.7365 116.526 69.7365H115.878ZM116.202 88.1523C114.682 88.1523 113.45 86.9202 113.45 85.4004V75.5235C113.45 74.0036 114.682 72.7715 116.202 72.7715C117.722 72.7715 118.954 74.0036 118.954 75.5235V85.4004C118.954 86.9202 117.722 88.1523 116.202 88.1523Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4798_695",
    x1: 161.005,
    y1: 32.3393,
    x2: 133.958,
    y2: 97.5699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF5AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#4597F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#33F7BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackRentAiVertical);
export default __webpack_public_path__ + "static/media/Black_RentAI_Vertical.8e1d21959e02f5066e3b3318b3b8c727.svg";
export { ForwardRef as ReactComponent };